module.exports = __webpack_public_path__ + "img/图片15.5e4a8ef5.png";